<template>
  <el-card shadow="never">
    <div slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item v-show="facility" :to="{ name: 'Facility Units', path: { facility } }">{{String($root.state.facilityData.code).toUpperCase()}} Units</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-tabs v-model="activeTab">
      <el-tab-pane label="Current Units" name="current">
        <el-card shadow="never">
          <el-button style="margin-top: 12px;" @click="addUnit">
            Add Unit
          </el-button>
          <el-button type="primary" size="medium" style="margin-top: 12px;" :disabled="loading" @click="getItemsForCSV">
            Export Price Sheet
          </el-button>
          <el-button type="primary" size="medium" style="margin-top: 12px;" :disabled="loading" @click="getItemsForRentRollCSV" :loading="exportRentRollLoading">
            Export Rent Roll
          </el-button>
          <el-table
            :data="units"
            style="width: 100%"
            v-loading="loading"
            empty-text="No Data"
            @row-click="routeToUnit"
            @sort-change="fetchWithSort"
          >
            <el-table-column
                property="name"
                label="Name"
                sortable="name"
                width="100"
            >
            </el-table-column>
            <!-- <el-table-column
                property="status"
                label="Status"
                >
            </el-table-column> -->
            <el-table-column
              property="type"
              label="Unit kind"
              width="100"
            >
            </el-table-column>
            <el-table-column
                property="computedSize"
                label="Unit Size"
                sortable="computedSize"
                :width="120"
              >
                <!-- <template slot-scope="scope">
                  <span>{{ scope.row.length * scope.row.width }} Sq ft.</span>
                </template> -->
            </el-table-column>
            <el-table-column
              label="Rented By"
              prop="rentedBy"
              sortable="custom"
              :width="200"
            >
                <template slot-scope="scope">
                  <span v-if="scope.row.customerEmail">
                    {{ scope.row.customerEmail.company }}
                  </span>
                </template>
            </el-table-column>
            <el-table-column label="Current Price" :width="150" prop="currentPrice">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.currentPrice">
                  {{ scope.row.currentPrice }}
                  <span v-if="securityFeeEnabled">
                    + {{ scope.row.securityFee | currencySign($root.state.facilityData) }}
                  </span>
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Asking Price" :width="180" prop="askingPrice" sortable>
              <template slot-scope="scope">
                <el-tag>
                  {{ scope.row.askingPrice | currencySign($root.state.facilityData) }}
                  <span v-if="securityFeeEnabled">
                    + {{ scope.row.securityFee | currencySign($root.state.facilityData) }}
                  </span>
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="Finance"
              :width="120"
              prop="leaseStatus"
            >
            <template slot="header">
                <el-select
                  label="Finance Status"
                  v-model="leaseSearch"
                  size="small"
                  placeholder="Finance"
                  no-match-text="Status not set"
                  no-data-text="Status not set"
                  @change="filterStatus"
                >
                  <el-option
                    v-for="status in leaseStatuses"
                    :key="status"
                    :label="$options.filters.printableStatus(status)"
                    :value="status"
                  >
                  </el-option>
                  <!-- <el-option
                    v-if="!search"
                    label="  "
                    value=""
                  >
                  </el-option> -->
                </el-select>
              </template>
              <template slot-scope="scope">
                <el-tag v-if="scope.row.leaseStatus && (scope.row.status !== 'AVAILABLE' && scope.row.status !== 'UNAVAIALBLE')" effect="plain"  class="status-text" :color="statusColor(scope.row.leaseStatus)">
                  {{scope.row.leaseStatus | printableStatus }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              property="status"
              sortable="status"
              :width="180"
            >
              <template slot="header">
                <el-select
                  size="small"
                  class="status"
                  label="Lease Status"
                  v-model="search"
                  placeholder="Status"
                  no-match-text="Status not set"
                  no-data-text="Status not set"
                  @change="filterStatus"
                >
                  <el-option
                    v-for="status in statuses"
                    :key="status"
                    :label="$options.filters.printableStatus(status)"
                    :value="status"
                  >
                  </el-option>
                  <!-- <el-option
                    v-if="!search"
                    label="  "
                    value=""
                  >
                  </el-option> -->
                </el-select>
              </template>
              <template slot-scope="scope">
                <el-tag effect="plain"  class="status-text" :color="statusColor(scope.row.status)">
                  {{ scope.row.status | printableStatus }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              property="tags"
              label="Tag"
              :width="400"
            >
              <template slot-scope="scope">
                <el-tag :key="tag.value" v-for="tag in scope.row.tags" disable-transitions effect="plain" size="mini">
                  {{tag.value}}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog title="New Unit" :visible.sync="dialogFormVisible" :close-on-click-modal="false" fullscreen>
            <NewSiteUnitType
              @unit-added="unitAdded"
            />
          </el-dialog>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="Past Units" name="past">
        <el-card shadow="never">
          <el-table v-loading="loading" :data="retiredUnits" @row-click="routeToUnit">
            <el-table-column label="Unit Name" prop="name"></el-table-column>
            <el-table-column label="Retired By" prop="retiredBy"></el-table-column>
            <el-table-column label="Reason" prop="retirementReason"></el-table-column>
          </el-table>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import axios from 'axios';
import { UNITS_API_BASE, ORG_API, UNIT_RENTAL_API_BASE } from '../env';
import NewSiteUnitType from './NewSiteUnitType';
import statuses, { leaseStatuses } from '../utils/status';
import { getFacility } from '../utils/commonApi';
import getMonthAndYear from '../utils/timing';
import exportToCsv, { exportToCsvV2, saveCsv } from '../utils/exportToCsv';
import { computeUnitPricing } from '../utils/pricing';

export default {
  name: 'Units',
  props: {
    facility: { type: String, required: true },
  },
  watch: {
    async facility() {
      if (this.loading) {
        this.abortController.abort();
        this.abortController = new AbortController();
      }
      this.facilityData = await getFacility(this.facility, {
        token: this.$keycloak.token,
        signal: this.abortController.signal
      });
      await this.getUnits();
      await this.getRetiredUnits();
    },
  },
  async mounted() {
    this.abortController = new AbortController();
    this.loading = true;
    this.facilityData = await getFacility(this.facility, {
      token: this.$keycloak.token,
      signal: this.abortController.signal
    });
    await this.getUnits();
    await this.getOrg();
    await this.getRetiredUnits();
    this.loading = false;
  },
  components: { NewSiteUnitType },
  data() {
    return {
      abortController: null,
      units: [],
      orgTheme: [],
      retiredUnits: [],
      loading: true,
      dialogFormVisible: false,
      search: '',
      leaseSearch: '',
      statuses,
      leaseStatuses,
      sortBy: 'name',
      sorting: true,
      activeTab: 'current',
      facilityData: null,
      exportRentRollLoading: false,
    };
  },
  computed: {
    securityFeeEnabled() {
      return this.facilityData && this.facilityData.securityFee && this.facilityData.securityFee.enabled && this.facilityData.securityFee.fee > 0;
    },
    list() {
      const list = [];
      statuses.forEach((status) => {
        list.push({ text: status, value: status });
      });
      return list;
    },
  },
  methods: {
    getItemsForCSV() {
      try {
        const unitData = this.units.map(item => ({
          UnitName: String(item.name || '-').replace(/,/g, ''),
          UnitSize: `${item.computedSize} SF`,
          QualityTier: String(item.tierQuality === 'AA' ? 'A+' : item.tierQuality || '-').replace(/,/g, ''),
          Price: String(this.$options.filters.currencySign(item.price, this.$root.state.facilityData.pricing.currency)).replace(/,/g, ''),
          StillFullPrice: String(this.$options.filters.currencySign(item.stillFullPrice, this.$root.state.facilityData.pricing.currency)).replace(/,/g, ''),
          SecurityFee: String(this.$options.filters.currencySign(item.securityFee, this.$root.state.facilityData.pricing.currency)).replace(/,/g, ''),
        }));

        const unitCsv = exportToCsvV2({
          UnitName: 'Unit Name',
          UnitSize: 'Unit Size',
          QualityTier: 'Quality Tier',
          Price: 'Price',
          StillFullPrice: 'Still Full Price',
          SecurityFee: 'Security Fee',
        }, unitData);

        saveCsv(unitCsv, `${this.$root.state.facilityData.code} Unit Price List ${getMonthAndYear(new Date())}`);
        this.$message.success({
          message: 'Download completed!',
        });
      } catch (err) {
        console.log(err);
        this.$message.error({
          message: 'Export failed',
        });
      }
    },
    async  getItemsForRentRollCSV() {
      this.exportRentRollLoading = true;
      try {
        const unitIds = this.units
          .filter(unit => unit.activeUnitRental)
          .map(item => item._id);
        const unitRentals = await this.getUnitRentals(unitIds);

        const unitsUpdated = [];
        this.units.forEach((unit) => {
          const rentals = unitRentals.filter(rental => rental.unit._id === unit._id && rental.status === 'RENTED');
          unitsUpdated.push({ ...unit, rentals });
        });
        // const unitData = unitRentals
        //   .filter(unitRental => unitRental.unitInvoice)
        //   .sort((a, b) => a.unit.name.localeCompare(b.unit.name))
        const unitData = unitsUpdated
          .map(item => ({
            UnitName: String(item.name || '-').replace(/,/g, ''),
            UnitSize: item.computedSize,
            CustomerName: item.rentals.length ? String(item.rentals[0].customer.company || '-').replace(/,/g, '') : '-',
            Price: item.rentals.length ? String(this.$options.filters.currencySign(item.rentals[0].updatedPrice ? item.rentals[0].updatedPrice : item.rentals[0].pricing.price, this.$root.state.facilityData.pricing.currency)).replace(/,/g, '') : String(this.$options.filters.currencySign(item.price)).replace(/,/g, ''),
            FinanceStatus: item.rentals.length && item.rentals[0].unitInvoice ? `${item.rentals[0].unitInvoice.status}` : '-',
            LeaseStatus: `${item.status}`,
            MoveOut: item.rentals.length ? this.$options.filters.formatDate(item.rentals[0].moveOut) : '-',
          }));

        const unitCsv = exportToCsv({
          UnitName: 'Unit Name',
          UnitSize: 'Unit Size',
          CustomerName: 'Customer Name',
          Price: 'Price',
          FinanceStatus: 'Finance Status',
          LeaseStatus: 'Lease Status',
          MoveOut: 'Move Out Date',
        }, unitData);

        saveCsv(unitCsv, `${this.$root.state.facilityData.code} Unit Rental List ${getMonthAndYear(new Date())}`);
        this.$message.success({
          message: 'Download completed!',
        });
      } catch (err) {
        console.log(err);
        this.$message.error({
          message: 'Export failed',
        });
      }
      this.exportRentRollLoading = false;
    },
    async getOrg() {
      try {
        const org = await axios.get(`${ORG_API}/theme`, {
          signal: this.abortController.signal,
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.orgTheme = org.data;
      } catch (err) {
        this.orgTheme = {
          colors: [],
        };
        this.$message.warning({
          title: 'Warning',
          message: 'Org theme not accessible',
        });
      }
    },
    async fetchWithSort({ column, prop, order }) {
      if (prop === 'rentedBy') {
        if (!order) {
          await this.getUnits();
          return;
        }
        this.loading = true;
        const isDescending = order === 'descending';
        const sortedUnits = [...this.units].sort((a, b) => {
          const nameA = this.getRentedByName(a);
          const nameB = this.getRentedByName(b);
          const aEmpty = !nameA;
          const bEmpty = !nameB;
          if (aEmpty || bEmpty) {
            if (aEmpty && bEmpty) {
              return 0;
            }
            return isDescending ? (aEmpty ? 1 : -1) : (aEmpty ? -1 : 1);
          }
          return isDescending
            ? nameB.localeCompare(nameA)
            : nameA.localeCompare(nameB);
        });
        this.units = sortedUnits;
        this.loading = false;
        return;
      }
      if (prop === 'name') {
        this.sortBy = prop;
        this.sorting = order === 'descending';
      } else if (prop === 'status') {
        this.sortBy = prop;
        this.sorting = order === 'descending';
      } else if (prop === 'price') {
        this.loading = true;
        if (order === 'descending') {
          this.units.sort((item1, item2) => item2.price - item1.price);
        } else {
          this.units.sort((item1, item2) => item1.price - item2.price);
        }
        this.loading = false;
        return;
      } else {
        this.sortBy = prop;
        this.sorting = order === 'descending';
      }

      await this.getUnits();
    },
    addUnit() {
      this.dialogFormVisible = true;
    },
    computeSecurityFee(unitSize) {
      return Math.round(((this.facilityData.securityFee.fee / 100) * unitSize) * 100) / 100;
    },
    async getUnits() {
      try {
        this.loading = true;
        const response = await axios.get(`${UNITS_API_BASE}/${this.facility}`, {
          signal: this.abortController.signal,
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
          params: {
            limit: 250,
            ...(this.search ? { status: this.search } : {}),
            ...(this.search === 'ALL' ? { status: null } : { status: this.search }),
            ...(this.leaseSearch ? { leaseStatus: this.leaseSearch } : {}),
            ...(this.leaseSearch === 'ALL' ? { leaseStatus: null } : { leaseStatus: this.leaseSearch }),
            ...(this.sortBy ? { sortBy: this.sortBy } : {}),
            ...(this.sorting ? { sorting: this.sorting } : {}),
            customers: true,
          },
        });

        const unitIds = response.data
          .filter(unit => unit.activeUnitRental)
          .map(item => item._id);
        const unitRentals = await this.getUnitRentals(unitIds);

        for (const unit of response.data) {
          unit.price = computeUnitPricing(unit, this.facilityData, false);
          unit.askingPrice = computeUnitPricing(unit, this.facilityData);
          unit.stillFullPrice = unit.price * (100 + this.facilityData.stillFullPrice) / 100;
          unit.securityFee = this.facilityData.securityFee && this.facilityData.securityFee.enabled ? this.computeSecurityFee(unit.computedSize) : 0;
          if (unit.activeUnitRental) {
              unit.currentPrice = unit.activeUnitRental ?
                this.$options.filters.currencySign(unit.activeUnitRental.updatedPrice ? unit.activeUnitRental.updatedPrice : unit.activeUnitRental.pricing.price, this.$root.state.facilityData.pricing.currency)
                : 0
          } else {
            const rentals = unitRentals.filter(rental => rental.unit._id === unit._id && rental.status === 'RENTED');
            if (rentals.length) {
              // filter rental with status rented or pending
              const rental = rentals.filter(rentalItem => rentalItem.status === 'RENTED' || rentalItem.status === 'PENDING')[0];
              unit.currentPrice = rental ?
                this.$options.filters.currencySign(rental.updatedPrice ? rental.updatedPrice : rental.pricing.price, this.$root.state.facilityData.pricing.currency)
                : 0
            }
          }
        }

        this.units = response.data;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$message.error({
          title: 'Error',
          message: err.message ? err.message : err.response.data,
        });
      }
    },
    async getUnitRentals(unitIds) {
      const response = await axios.get(`${UNIT_RENTAL_API_BASE}/${this.facility}/units`, {
        signal: this.abortController.signal,
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
        params: {
          units: unitIds.toString(),
        },
      });
      return response.data.result;
    },
    async getRetiredUnits() {
      try {
        this.loading = true;
        const units = await axios.get(`${UNITS_API_BASE}/retired/${this.facility}`, {
          signal: this.abortController.signal,
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
          params: {
            limit: 250,
          },
        });
        this.retiredUnits = units.data;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$notify.error({
          title: 'Error',
          message: err.message ? err.message : err.response.data,
        });
      }
    },
    async unitAdded(unit) {
      try {
        this.dialogFormVisible = false;

        await axios.post(`${UNITS_API_BASE}/unit`, { ...unit, facility: this.facility, size: Number(unit.size) }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        await this.getUnits();
      } catch (err) {
        this.$message.error({
          title: 'Error',
          message: err.response && err.response.data ? err.response.data : err.message,
        });
      }
    },
    async filterStatus() {
      // this.search = data;
      await this.getUnits();
    },
    statusColor(status) {
      const [foundColor] = this.orgTheme.filter((item) => {
        if (status === item.type) {
          return item;
        }
      });
      return foundColor.color || '#efefef';
    },
    routeToHomePage() {
      this.$router.push('/');
    },
    routeToUnit(row) {
      // eslint-disable-next-line no-underscore-dangle
      this.$router.push({ name: 'Facility Unit', params: { unit: row._id, facility: this.facility } });
    },
    getRentedByName(unit) {
      if (!unit || !unit.customerEmail || !unit.customerEmail.company) {
        return '';
      }
      return String(unit.customerEmail.company).trim().toLowerCase();
    },
  },
};
</script>

<style scoped>
.status-text{
  color: beige;
  border: none;
  text-align: center;
}
.status {
  width: 7rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Units.vue